<template>
  <mvtDropdownList
      size="small"
      btnClass="filter square"
      :items="sortByData"
      :label="sortBy ? null : sortByData[0].labelText"
      :defaultValue="sortByData[0].value"
      :hideReset="true"
      v-model="sortBy"
  />
</template>

<script src="./search-sort.js"></script>
